import { render, staticRenderFns } from "./ProjectSummaryComponent.vue?vue&type=template&id=59af4513"
import script from "./ProjectSummaryComponent.vue?vue&type=script&lang=js"
export * from "./ProjectSummaryComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectSummaryComponent.vue?vue&type=style&index=0&id=59af4513&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports